import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {LanguageDropdownModule} from 'shared/language-dropdown/language-dropdown.module';
import {CModulesDetailsRoutingModule} from './cmodules-details-routing.module';
import {CModulesDetailsComponent} from './cmodules-details.component';
import {CModulesDetailsHttpRepository} from './repositories/cmodules-details.repository.http';
import {CModulesDetailsService} from './services/cmodules-details.service';
import {CModuleDatepickerModule} from './cmodules-datepicker/cmodules-datepicker.module';

import {DragulaModule} from 'ng2-dragula';
import {TooltipModule} from 'ng2-bootstrap/tooltip';
import { TabsModule, TabsetConfig } from 'ng2-bootstrap/tabs';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CModulesDetailsRoutingModule,
    LanguageDropdownModule,
    DragulaModule,
    CModuleDatepickerModule,
    TooltipModule.forRoot(),
    TabsModule
  ],
  declarations: [
    CModulesDetailsComponent,
  ],
  providers: [
    CModulesDetailsService,
    {
      provide: 'ICModulesDetailsRepository',
      useClass: CModulesDetailsHttpRepository,
    },
    TabsetConfig
  ],
})
export class CModulesDetailsModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/cmodules/cmodules-details/cmodules-details.module.ts